import { normalizeRelation } from './normalizeRelation';

/**
 * Converts a relation string based on gender change
 * @param {string} relation - The relation string to convert (e.g., "Son", "Granddaughter-in-law", "Gr Gr Grandson")
 * @param {string} targetGender - Target gender: "1" for Male, "2" for Female
 * @returns {string} - The converted relation string
 */
export function convertRelationByGender(relation, targetGender) {
    if (!relation || !targetGender) return relation;
    
    const relationLower = relation.toLowerCase();
    const isTargetMale = targetGender === "1";
    const isTargetFemale = targetGender === "2";
    
    // Handle "Self" - should remain "Self" for generation 1
    if (relationLower === "self") {
        return "Self";
    }
    
    // Handle root head cases
    if (relationLower.includes("grandfather") && relationLower.includes("root head")) {
      return isTargetFemale ? "Grandmother - Root Head of Family" : "Grandfather - Root Head of Family";
    }
    if (relationLower.includes("grandmother") && relationLower.includes("root head")) {
      return isTargetMale ? "Grandfather - Root Head of Family" : "Grandmother - Root Head of Family";
    }
    if (relationLower.includes("grandmother") && relationLower.includes("spouse")) {
      return isTargetMale ? "Grandfather - Spouse" : "Grandmother - Spouse";
    }
    if (relationLower.includes("grandfather") && relationLower.includes("spouse")) {
      return isTargetFemale ? "Grandmother - Spouse" : "Grandfather - Spouse";
    }
    
    // Extract prefixes (Gr, Great, Grand)
    let prefix = "";
    let remaining = relation;
    
    // Count "Gr " prefixes
    while (remaining.toLowerCase().startsWith("gr ")) {
      prefix += "Gr ";
      remaining = remaining.slice(3).trim();
    }
    
    // Handle "Great-" prefix
    while (remaining.toLowerCase().startsWith("great-")) {
      prefix += "Great-";
      remaining = remaining.slice(6).trim();
    }
    
    // Handle "Grand" prefix
    if (remaining.toLowerCase().startsWith("grand")) {
      prefix += "Grand";
      remaining = remaining.slice(5).trim();
    }
    
    // Convert the base relation
    const baseLower = remaining.toLowerCase();
    let convertedBase = remaining;
    
    // Convert Son ↔ Daughter
    if (baseLower === "son") {
      convertedBase = isTargetFemale ? "Daughter" : "Son";
    } else if (baseLower === "daughter") {
      convertedBase = isTargetMale ? "Son" : "Daughter";
    }
    // Convert Grandson ↔ Granddaughter
    else if (baseLower === "grandson") {
      convertedBase = isTargetFemale ? "Granddaughter" : "Grandson";
    } else if (baseLower === "granddaughter") {
      convertedBase = isTargetMale ? "Grandson" : "Granddaughter";
    }
    // Convert Son-in-law ↔ Daughter-in-law
    else if (baseLower === "son-in-law") {
      convertedBase = isTargetFemale ? "Daughter-in-law" : "Son-in-law";
    } else if (baseLower === "daughter-in-law") {
      convertedBase = isTargetMale ? "Son-in-law" : "Daughter-in-law";
    }
    // Convert Grandson-in-law ↔ Granddaughter-in-law
    else if (baseLower === "grandson-in-law") {
      convertedBase = isTargetFemale ? "Granddaughter-in-law" : "Grandson-in-law";
    } else if (baseLower === "granddaughter-in-law") {
      convertedBase = isTargetMale ? "Grandson-in-law" : "Granddaughter-in-law";
    }
    
    // Reconstruct the relation
    const result = prefix + convertedBase;
    // Normalize to ensure proper capitalization (Grandson not GrandSon, Granddaughter not GrandDaughter)
    return normalizeRelation(result);
  }